import PaymentsReport from "./PaymentsReport";

export default PaymentsReport;
